// Shared "Ситуация дня" modal — used by both WorldScreen (Мир) and ActionsScreen
// (Действия). Body shows the full narrative (fullText); «Задача» shows the full
// centralProblem (mainObjective is a 102-char backend truncation of it).

import { type CampaignSetup } from "../api";

type Situation = NonNullable<CampaignSetup["commandHub"]>["situation"];

export function SituationModal({ situation, onClose }: { situation: Situation; onClose: () => void }) {
  const full = situation.fullText || situation.shortText;
  const task = situation.centralProblem || situation.mainObjective;
  return (
    <div className="gn-modal-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="gn-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gn-modal-head">
          <span className="gn-eyebrow">Ситуация дня</span>
          <button type="button" className="gn-modal-x" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>
        <h2>{situation.title}</h2>
        <div className="gn-modal-body">
          {full.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        {task && (
          <p className="gn-modal-obj">
            <b>Задача:</b> {task}
          </p>
        )}
      </div>
    </div>
  );
}
